import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { ValueStream } from "@common/ADAPT.Common.Model/organisation/value-stream";
import { BaseEntity } from "../base-entity";
import { BreezeModelBuilder } from "../breeze-model-builder";
import { Role } from "./role";

export class RoleLocation extends BaseEntity<RoleLocation> {
    public roleLocationId!: number;
    public roleId!: number;
    public teamId?: number;
    public valueStreamId?: number;

    public role!: Role;
    public team?: Team;
    public valueStream?: ValueStream;
}

export const RoleLocationBreezeModel = new BreezeModelBuilder("RoleLocation", RoleLocation)
    .hasSource()
    .isOrganisationEntity()
    .build();
